import { createReducer, createSelector } from 'redux-starter-kit';
import {putLocation, putLocations, putLocationsForSelect, removeLocation} from './locationActions';


/**
 * A selector for the locations map
 */
export const selectLocationsMap = state => state.via.domain.locations;

/**
 * A selector for the locations
 */
export const selectLocations = createSelector(['via.domain.locations'], map => (map ? Object.values(map) : null));

/**
 * A selector for a single location.
 */
export const selectLocation = (state, locationId) => {
    const locMap = selectLocationsMap(state);
    if (!locMap) return null;

    return locMap[locationId];
};

const initialLocations = {};

/**
 * A reducer for managing locations
 */
const locationReducer = createReducer(initialLocations, {
    // Inserts/Updates one
    [putLocation]: (state, action) => {
        const location = action.payload;

        return {
            ...state,
            [location.locationCode]: location,
        };
    },

    // Removes one
    [removeLocation]: (state, action) => {
        const locationCode = action.payload;
        const newState = { ...state };
        delete newState[locationCode];
        return newState;
    },

    // Inserts/Updates all
    [putLocations]: (state, action) => {
        const locations = action.payload;
        return locations.reduce((newState, location) => {
            newState[location.locationCode] = location; // eslint-disable-line no-param-reassign
            return newState;
        }, { ...initialLocations });
    },

    [putLocationsForSelect]: (state, action) => {
        const locations = action.payload;
        return locations.reduce((newState, location) => {
            newState[location.locationCode] = location; // eslint-disable-line no-param-reassign
            return newState;
        }, { ...initialLocations });
    },
});

export default locationReducer;
